// extracted by mini-css-extract-plugin
module.exports = {"qrcode":"qrcode-control_qrcode__B237K"};